module.exports = __webpack_public_path__ + "img/159.8948a95d.jpg";